import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { ENUM_PROJECT_STATUS_CATEGORY } from "../../../enums/project";
import { ROUTE_PATHS } from "../../../routes/paths";

const INVITATION_REMINDER_ACTIONS = new Set([
  "reschedule",
  "confirm-attendance",
]);

export default function ProjectInvitationReminder() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  if (!id) {
    return <Navigate to={ROUTE_PATHS.PROJECT.LIST} replace />;
  }

  const redirectParams = new URLSearchParams({
    id,
    type: ENUM_PROJECT_STATUS_CATEGORY.UPCOMING,
  });
  const action = searchParams.get("action");

  if (action && INVITATION_REMINDER_ACTIONS.has(action)) {
    redirectParams.set("action", action);
  }

  return (
    <Navigate
      to={`${ROUTE_PATHS.PROJECT.LIST}?${redirectParams.toString()}`}
      replace
    />
  );
}
